import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContextWidgetInstancesService {
  numberOfInstances: number = 0;
  opened;

  constructor() {}

  addInstance() {
    this.numberOfInstances++;
  }

  removeInstance() {
    this.numberOfInstances--;
  }

  hasInstance() {
    return this.numberOfInstances > 0;
  }

  hasMultipleInstances() {
    return this.numberOfInstances > 1;
  }
}
